export const initialGameState = {
  phase: 'join',
  roomCode: '',
  playerName: '',
  playerId: '',
  players: [],
  playerScore: 0,
  isGameController: false,
  gameOptions: { disableTimers: false, extendedRounds: false, simplifiedDrawing: false },
  statusMessage: '',
  finalResults: null,
};

export function gameReducer(state, action) {
  switch (action.type) {
    case 'SET_PHASE':
      return {
        ...state,
        phase: action.phase,
        ...(action.statusMessage !== undefined && { statusMessage: action.statusMessage }),
      };

    case 'SET_ROOM_CODE':
      return { ...state, roomCode: action.roomCode };

    case 'SET_PLAYER_NAME':
      return { ...state, playerName: action.playerName };

    case 'SET_STATUS':
      return { ...state, statusMessage: action.statusMessage };

    case 'JOIN_SUCCESS':
      return {
        ...state,
        phase: 'lobby',
        playerId: action.playerId,
        players: action.players,
        isGameController: action.isGameController,
        playerScore: action.playerScore ?? state.playerScore,
        statusMessage: action.statusMessage,
        ...(action.gameOptions && { gameOptions: action.gameOptions }),
      };

    case 'CONTROLLER_CHANGED':
      return {
        ...state,
        isGameController: action.isGameController,
        statusMessage: action.statusMessage,
      };

    case 'SET_GAME_OPTION':
      return { ...state, gameOptions: { ...state.gameOptions, [action.key]: action.value } };

    case 'STATE_UPDATE': {
      const d = action.dto;
      const phase = d.gameState === 'lobby' ? 'lobby'
        : d.gameState === 'playing' ? 'playing'
        : d.gameState === 'finished' ? 'finished'
        : state.phase;
      return {
        ...state,
        phase,
        playerId: d.playerId || state.playerId,
        players: d.players,
        isGameController: d.isGameController,
        playerScore: d.playerScore,
        gameOptions: d.gameOptions,
        ...(d.finalResults && { finalResults: d.finalResults }),
      };
    }

    case 'RESET':
      return { ...initialGameState };

    default:
      return state;
  }
}
